import { FaPhone, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import { FaXTwitter, FaFacebook, FaPinterest, FaInstagram, FaLinkedin, FaYoutube, FaTiktok } from 'react-icons/fa6';
import { contactInfo } from '../../data/siteData';
import './TopBar.css';

const TopBar = () => {
  const telHref = `tel:${contactInfo.phone1.replace(/[^0-9+]/g, '')}`;
  const waDigits = contactInfo.whatsapp.replace(/[^0-9]/g, '');
  const waHref = `https://wa.me/${waDigits}`;

  return (
    <div className="top-bar">
      <div className="container">
        <div className="top-bar-inner">
          <div className="top-bar-content">
            <span className="contact-info">
              <FaPhone /> <a href={telHref}>{contactInfo.phone1}</a> | 
              <FaWhatsapp /> <a href={waHref} target="_blank" rel="noopener noreferrer">{contactInfo.whatsapp}</a> | 
              <FaEnvelope /> <a href="#">Info@alnoortutors.com</a>
            </span>
          </div>
          
          <div className="top-bar-social">
            <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FaXTwitter />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebook />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Pinterest">
              <FaPinterest />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <FaTiktok />
            </a>
          </div>
        </div>
      </div>
      
      {/* WhatsApp Floating Button */}
      <a href={waHref} target="_blank" rel="noopener noreferrer" className="whatsapp-float">
        <div className="whatsapp-icon">
          <FaWhatsapp />
        </div>
      </a>
    </div>
  );
};

export default TopBar;
